"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUAConnectionEstablished = void 0;
const isUAConnectionEstablished = state => state.ua.connectionEstablished;
exports.isUAConnectionEstablished = isUAConnectionEstablished;